(function () {
  var DISCOUNT_API = "https://aiod.cirkleinc.com/api/display-discount-table";
  var cache = null;
  var cacheAt = 0;
  var CACHE_MS = 5 * 60 * 1000;
  var adding = false;

  function shopDomain() {
    var shopify = window.Shopify || {};
    return shopify.shop || "";
  }

  function currencyCode() {
    var shopify = window.Shopify || {};
    return (shopify.currency && shopify.currency.active) || "CAD";
  }

  function countryCode() {
    var shopify = window.Shopify || {};
    return shopify.country || "CA";
  }

  function fetchTable(requestType) {
    var params = new URLSearchParams({
      shop: shopDomain(),
      request_type: String(requestType),
      currency: currencyCode(),
      country: countryCode(),
    });
    return fetch(DISCOUNT_API + "?" + params.toString(), { credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("discount-" + requestType);
      return response.json();
    }).catch(function () {
      return { data: [] };
    });
  }

  function loadOffers() {
    var now = Date.now();
    if (cache && now - cacheAt < CACHE_MS) return Promise.resolve(cache);
    return fetchTable(3).then(function (bogo) {
      cache = {
        bogo: (bogo && bogo.data) || [],
        gift: [],
      };
      cacheAt = now;
      return cache;
    });
  }

  function qtyForProducts(cart, productIds, skipIds) {
    var allowed = {};
    var skip = {};
    var open = !productIds || !productIds.length;
    (productIds || []).forEach(function (id) {
      allowed[String(id)] = true;
    });
    (skipIds || []).forEach(function (id) {
      skip[String(id)] = true;
    });
    var total = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      var pid = String(item.product_id);
      if (skip[pid]) return;
      if (open || allowed[pid]) total += Number(item.quantity) || 0;
    });
    return total;
  }

  function productIdsFrom(row, key) {
    return ((row && row[key]) || [])
      .map(function (product) {
        return product && product.product_id != null ? String(product.product_id) : "";
      })
      .filter(Boolean);
  }

  function firstVariantId(product) {
    if (!product || product.default_variant_ids == null) return "";
    return String(product.default_variant_ids).split(",")[0].trim();
  }

  function missingGetItems(cart, row) {
    if (!row || String(row.status) !== "1") return [];
    var buy = parseInt(row.bogo_quantity_buy || row.quantity_buy || row.quantity, 10);
    var getQty = parseInt(row.bogo_quantity_get || row.quantity_get || 1, 10) || 1;
    var buyIds = productIdsFrom(row, "products");
    var getProducts = row.products_get || row.gift_products || [];
    if (!buy || buy < 1 || !getProducts.length) return [];

    var getIds = productIdsFrom(row, "products_get");
    if (!getIds.length) {
      getIds = getProducts
        .map(function (product) {
          return product && product.product_id != null ? String(product.product_id) : "";
        })
        .filter(Boolean);
    }
    var qualifying = qtyForProducts(cart, buyIds, getIds);
    var needed = Math.floor(qualifying / buy) * getQty;
    var limit = parseInt(row.offer_limit, 10);
    if (limit > 0) needed = Math.min(needed, limit);
    if (needed < 1) return [];

    var items = [];
    getProducts.forEach(function (product) {
      var variantId = firstVariantId(product);
      if (!variantId) return;
      var have = qtyForProducts(cart, [String(product.product_id)]);
      var missing = needed - have;
      if (missing > 0) {
        items.push({ id: Number(variantId), quantity: missing });
      }
    });
    return items;
  }

  function collectAdds(cart, offers) {
    var items = [];
    function pushRow(row) {
      missingGetItems(cart, row).forEach(function (item) {
        var existing = items.filter(function (entry) {
          return entry.id === item.id;
        })[0];
        if (existing) existing.quantity = Math.max(existing.quantity, item.quantity);
        else items.push(item);
      });
    }
    (offers.bogo || []).forEach(pushRow);
    (offers.gift || []).forEach(pushRow);
    return items;
  }

  function refreshDrawer() {
    var provider = document.querySelector("cart-provider");
    if (!provider || typeof provider._getDrawerSection !== "function") return Promise.resolve();
    if (!provider.features || !provider.features.drawer) return Promise.resolve();
    return Promise.all([provider._getDrawerSection(), provider._getCartMeta()]).then(function (parts) {
      return provider.publish("cart:update", {
        meta: parts[1],
        drawer: { section: parts[0], open: false },
      });
    });
  }

  function publishCartAdd(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      if (!response.ok) throw new Error("cart-add");
      return refreshDrawer();
    });
  }

  function syncOffers() {
    if (adding || !shopDomain()) return;
    adding = true;
    Promise.all([
      fetch("/cart.js", { credentials: "same-origin" }).then(function (response) {
        if (!response.ok) throw new Error("cart");
        return response.json();
      }),
      loadOffers(),
    ])
      .then(function (results) {
        var items = collectAdds(results[0], results[1]);
        if (!items.length) return;
        return publishCartAdd(items);
      })
      .catch(function () {})
      .then(function () {
        window.setTimeout(function () {
          adding = false;
        }, 1500);
      });
  }

  document.addEventListener("cart:update", syncOffers, true);
})();
